module.exports = __webpack_public_path__ + "logo-megalink.png?3275bebc45b206ffeb05d4988775de33";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-megalink.png
// module id = 247
// module chunks = 0